module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_3009.d55ad39f.png";